const useBrowserStorage = (mapContext) => {
  const saveLayerVisibility = ({ layerName, value }) => {
    const layerData = mapContext.retriveStoredLayerVisibility();
    switch (layerName) {
      case "photoPointLayer":
        layerData.layerVisibility.photoPoints = value;
        break;
      case "addressLayer":
        layerData.layerVisibility.address = value;
        break;
      case "conduitLayer":
        layerData.layerVisibility.conduit = value;
        break;
      case "fiberCableLayer":
        layerData.layerVisibility.fibercable = value;
        break;
      case "lcpLayer":
        layerData.layerVisibility.lcpBoundaries = value;
        break;
      case "parcelLayer":
        layerData.layerVisibility.parcels = value;
        break;
      case "polesLayer":
        layerData.layerVisibility.poles = value;
        break;
      case "spliceClosureLayer":
        layerData.layerVisibility.spliceClosures = value;
        break;
      case "strandLayer":
        layerData.layerVisibility.strand = value;
        break;
      case "structureLayer":
        layerData.layerVisibility.structures = value;
        break;
      default:
        break;
    }
    mapContext.saveLayerVisibility(layerData.layerVisibility);
  };

  const saveBasemapValue = (basemap) => {
    switch (basemap) {
      case "Dark Gray Canvas":
        mapContext.saveBasemap("dark-gray-vector");
        break;
      case "Light Gray Canvas":
        mapContext.saveBasemap("gray-vector");
        break;
      case "Imagery with Labels":
        mapContext.saveBasemap("hybrid");
        break;
      case "Oceans":
        mapContext.saveBasemap("oceans");
        break;
      case "OpenStreetMap":
        mapContext.saveBasemap("osm");
        break;
      case "Imagery":
        mapContext.saveBasemap("satellite");
        break;
      case "World Navigation Map":
        mapContext.saveBasemap("streets-navigation-vector");
        break;
      case "World Street Map (Night)":
        mapContext.saveBasemap("streets-night-vector");
        break;
      case "World Street Map (with Relief)":
        mapContext.saveBasemap("streets-relief-vector");
        break;
      case "Streets":
        mapContext.saveBasemap("streets-vector");
        break;
      case "Terrain with Labels":
        mapContext.saveBasemap("terrain");
        break;
      case "Topographic":
        mapContext.saveBasemap("topo-vector");
        break;
      default:
        break;
    }
  };

  return { saveLayerVisibility, saveBasemapValue };
};

export default useBrowserStorage;
